export default function BusinessBanner() {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-[#FAF0E6] to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <a 
          href="/business"
          className="block group"
        >
          <div className="bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-300 group-hover:scale-[1.02]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              <div className="p-8 sm:p-10 lg:p-16 flex flex-col justify-center space-y-6 sm:space-y-8">
                <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-medium self-start whitespace-nowrap">
                  <i className="ri-building-line text-lg"></i>
                  企業・事業者様向け
                </div>

                <div className="space-y-4">
                  <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
                    デジタル制作サービス
                  </h2>
                  <p className="text-base sm:text-lg text-white/90 leading-relaxed">
                    チラシ制作・ネットショップ立ち上げ・タスク効率化アプリ制作など、お客様のニーズを汲み取り、ビジネスの成長に貢献いたします。
                  </p>
                </div>

                <div className="inline-flex items-center gap-2 bg-white text-[#66BB6A] px-8 py-4 rounded-full text-lg font-bold shadow-xl group-hover:shadow-2xl group-hover:scale-105 transition-all self-start whitespace-nowrap">
                  詳しく見る
                  <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>

              <div className="relative min-h-[300px] sm:min-h-[400px] lg:min-h-0 bg-white p-4 sm:p-6 lg:p-8 flex items-center justify-center">
                <img 
                  alt="企業向けデジタル制作サービス案内 - チラシ制作・ネットショップ立ち上げ・タスク効率化アプリ制作の料金表とサービス詳細" 
                  className="w-full h-full object-contain object-center max-w-full" 
                  src="https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/bea6269f0c969db34f1ade348debfef6.png"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}
